import {isNumber, trim} from 'lodash-es';
import {storeToRefs} from 'pinia';

import {useTranslationsStore} from '@/store/translations';

export function getPlusMinusPrefix(value) {
    let prefix = '';
    if (value < 0) {
        prefix = '＋';
    } else if (value > 0) {
        prefix = '－';
    }
    return prefix;
}

export function formatDiffAmount(value) {
    const translationStore = useTranslationsStore();
    const { formatCurrency } = storeToRefs(translationStore);

    const roundedAmount = +value.toFixed(2)
    const prefix = getPlusMinusPrefix(roundedAmount);
    return `${prefix} ${formatCurrency.value(Math.abs(roundedAmount))}`
}

export function formatDiffNumber(value) {
    const prefix = getPlusMinusPrefix(value);
    return `${prefix} ${Math.abs(value).toFixed(2)}`
}

export function formattedValue(value) {
    if (value === null) {
        return '…';
    }
    return value;
}

export function roundNumber(value) {
    if (isNumber(value)) {
        // toFixed: 0.49 => 0.5
        // round: 0.5 => 1
        value = Math.round(value.toFixed(1));
    }
    return value;
}

export function dotDotDotWhenFalsy(value) {
    if (value === null || value === undefined) {
        return '…';
    }
    return value;
}

export function getPluralTerm(value, pluralId, singularId) {
    const isPlural = (value) => {
        try {
            const intValue = parseInt(value);
            return intValue !== 1;
        } catch (error) {
            return false;
        }
    };

    const translationStore = useTranslationsStore();
    const {trans} = storeToRefs(translationStore);
    return trim(
        isPlural(value) ? trans.value(pluralId) : trans.value(singularId)
    );
}


